import { createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';
import { UploadStatus } from './upload.reducer';

export const selectUploadState = createSelector(selectDashboardState, (dashboard) => dashboard?.upload);

export const selectUpload = (id: string) =>
  createSelector(selectUploadState, (uploadState) => uploadState.entities[id]);

export const selectStarted = (id: string) =>
  createSelector(selectUpload(id), (upload) => upload?.status === UploadStatus.STARTED);

export const selectRequested = (id: string) =>
  createSelector(selectUpload(id), (upload) => upload?.status === UploadStatus.REQUESTED);

export const selectReady = (id: string) =>
  createSelector(selectUpload(id), (upload) => upload?.status === UploadStatus.READY);

export const selectProgress = (id: string) => createSelector(selectUpload(id), (upload) => upload?.progress);

export const selectInProgress = (id: string) =>
  createSelector(selectUpload(id), (upload) => upload?.status === UploadStatus.STARTED && upload?.progress >= 0);

export const selectFailed = (id: string) =>
  createSelector(selectUpload(id), (upload) => upload?.status === UploadStatus.FAILED);

export const selectCompleted = (id: string) =>
  createSelector(selectUpload(id), (upload) => upload?.status === UploadStatus.COMPLETED);

export const selectError = (id: string) => createSelector(selectUpload(id), (upload) => upload?.error);

export const selectUploaded = (id: string) => createSelector(selectUpload(id), (upload) => upload?.uploaded);
